import { queryOptions } from "@tanstack/react-query";
import type { ScheduledChangesResponse } from "@/app/billing/types";
import { getCoordinatorApi } from "@/lib/api";
import { billingKeys } from "./query-keys";

const fetchScheduledChanges = async ({
  organizationId,
}: {
  organizationId: string;
}): Promise<ScheduledChangesResponse> => {
  const api = getCoordinatorApi({ organizationId });
  const { data } = await api.get<ScheduledChangesResponse>(
    "/billing/subscription_schedule/upcoming"
  );

  return data;
};

export const scheduledChangesQueryOptions = ({
  organizationId,
}: {
  organizationId: string;
}) =>
  queryOptions<ScheduledChangesResponse>({
    queryKey: billingKeys.scheduledChange(organizationId),
    queryFn: () => fetchScheduledChanges({ organizationId }),
  });
